function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import moment from 'moment/moment';
import { formatTimestamp } from 'helpers/datetime';
const isInRange = (value, range)=>{
    const re = /^(([0-1][0-9])|(2[0-3])):[0-5][0-9]$/;
    const [start, end] = range;
    // Validate values
    if ([
        value,
        start,
        end
    ].some((val)=>!re.test(val))) {
        return;
    }
    // If start less than end, assume doesn't go over midnight
    if (start <= end) {
        // eslint-disable-next-line consistent-return
        return value >= start && value < end;
    // Otherwise, assume goes over midnight
    }
    // eslint-disable-next-line consistent-return
    return value >= start || value < end;
};
const acceptedMeals = [
    'Breakfast',
    'Dinner',
    'Lunch'
];
const useRows = (gestationalReportSettings, reportsDates, readings)=>{
    const days = [
        ...Array(reportsDates.days).keys()
    ].reduce((res, elem, index)=>[
            ...res,
            moment(reportsDates.startDate).add(index, 'd').format('L')
        ], []);
    const inRange = gestationalReportSettings.reduce((res, elem, index, array)=>_object_spread_props(_object_spread({}, res), {
            [index]: readings.filter((reading)=>{
                let isChecked = false;
                if (acceptedMeals.includes(reading.mealType)) {
                    isChecked = true;
                    if (reading.mealType.toLowerCase() === gestationalReportSettings[index].id) {
                        return true;
                    }
                }
                if (!isChecked) {
                    const b = array[index].value;
                    const a = formatTimestamp(reading.timestamp, 'HH:mm');
                    if (array[index + 1]) {
                        const c = array[index + 1].value;
                        return isInRange(a, [
                            b,
                            c
                        ]);
                    }
                    const c = array[0].value;
                    return isInRange(a, [
                        b,
                        c
                    ]);
                }
                return false;
            })
        }), {});
    const readingsRow = days.reduce((daysObj, day)=>{
        const tmpDay = {};
        for (const [mealType, readingsInMealTime] of Object.entries(inRange)){
            tmpDay[mealType] = readingsInMealTime.filter((reading)=>formatTimestamp(reading.timestamp) === day);
        }
        return [
            ...daysObj,
            {
                id: day,
                values: Object.values(tmpDay)
            }
        ];
    }, []);
    return readingsRow;
};
export default useRows;
